export namespace CCC {

  //Message Types
  export const types = {
    'TRADE': '0',
    'FEEDNEWS': '1',
    'CURRENT': '2',
    'LOADCOMPLATE': '3',
    'COINPAIRS': '4',
    'CURRENTAGG': '5',
    'TOPLIST': '6',
    'TOPLISTCHANGE': '7',
    'ORDERBOOK': '8',
    'FULLORDERBOOK': '9',
    'ACTIVATION': '10',
    'FULLVOLUME': '11',
    'TRADECATCHUP': '100',
    'NEWSCATCHUP': '101',
    'TRADECATCHUPCOMPLETE': '300',
    'NEWSCATCHUPCOMPLETE': '301'
  }

  export namespace Currency {

    export const symbols: { [key: string]: string } = {
      'BTC': 'Ƀ',
      'LTC': 'Ł',
      'DAO': 'Ð',
      'USD': '$',
      'CNY': '¥',
      'EUR': '€',
      'GBP': '£',
      'JPY': '¥',
      'PLN': 'zł',
      'RUB': '₽',
      'ETH': 'Ξ',
      'GOLD': 'Gold g',
      'INR': '₹',
      'BRL': 'R$'
    }

    export function getSymbol(symbol: string): string {
      return symbols[symbol] || symbol;
    }
  }

  export namespace Util {
    export function convertToMB(bytes: string): string {
      return (parseInt(bytes, 10) / 1024 / 1024).toFixed(2) + ' MB';
    }

  }

  export namespace Current {
    export const fields: { [key: string]: number } = {
      'TYPE': 0x0 // hex for binary 0, it is a special case of fields that are always there
      , 'MARKET': 0x0 // hex for binary 0, it is a special case of fields that are always there
      , 'FROMSYMBOL': 0x0 // hex for binary 0, it is a special case of fields that are always there
      , 'TOSYMBOL': 0x0 // hex for binary 0, it is a special case of fields that are always there
      , 'FLAGS': 0x0 // hex for binary 0, it is a special case of fields that are always there
      , 'PRICE': 0x1 // hex for binary 1
      , 'BID': 0x2 // hex for binary 10
      , 'OFFER': 0x4 // hex for binary 100
      , 'LASTUPDATE': 0x8 // hex for binary 1000
      , 'AVG': 0x10 // hex for binary 10000
      , 'LASTVOLUME': 0x20 // hex for binary 100000
      , 'LASTVOLUMETO': 0x40 // hex for binary 1000000
      , 'LASTTRADEID': 0x80 // hex for binary 10000000
      , 'VOLUMEHOUR': 0x100 // hex for binary 100000000
      , 'VOLUMEHOURTO': 0x200 // hex for binary 1000000000
      , 'VOLUME24HOUR': 0x400 // hex for binary 10000000000
      , 'VOLUME24HOURTO': 0x800 // hex for binary 100000000000
      , 'OPENHOUR': 0x1000 // hex for binary 1000000000000
      , 'HIGHHOUR': 0x2000 // hex for binary 10000000000000
      , 'LOWHOUR': 0x4000 // hex for binary 100000000000000
      , 'OPEN24HOUR': 0x8000 // hex for binary 1000000000000000
      , 'HIGH24HOUR': 0x10000 // hex for binary 10000000000000000
      , 'LOW24HOUR': 0x20000 // hex for binary 100000000000000000
      , 'LASTMARKET': 0x40000 // hex for binary 1000000000000000000, this is a special case and will only appear on CCCAGG messages
    };

    export function unpack(message: string): Ticker {
      let valuesArray = message.split("~");
      let valuesArrayLenght = valuesArray.length;
      let mask = valuesArray[valuesArrayLenght - 1];
      let maskInt = parseInt(mask, 16);
      let unpackedCurrent: any = {};
      let currentField = 0;

      for (let property in fields) {
        if (fields[property] === 0) {
          unpackedCurrent[property] = valuesArray[currentField];
          currentField++;
        }
        else if (maskInt & fields[property]) {
          //i know this is a hack, for cccagg, future code please don't hate me:(, i did this to avoid
          //subscribing to trades as well in order to show the last market
          if (property === 'LASTMARKET') {
            unpackedCurrent[property] = valuesArray[currentField];
          }
          else {
            unpackedCurrent[property] = parseFloat(valuesArray[currentField]);
          }
          currentField++;
        }
      }

      return (<Ticker>unpackedCurrent);
    }
  }

  export interface Ticker {
    TYPE?: string;
    MARKET?: string;
    FROMSYMBOL?: string;
    TOSYMBOL?: string;
    FLAGS?: string;
    PRICE?: number;
    LASTUPDATE?: number;
    LASTVOLUME?: number;
    LASTVOLUMETO?: number;
    LASTTRADEID?: string;
    VOLUME24HOUR?: number;
    VOLUME24HOURTO?: number;
    OPEN24HOUR?: number;
    HIGH24HOUR?: number;
    LOW24HOUR?: number;
    CHANGE24HOUR?: string;
    CHANGE24HOURPCT?: string;
  }
}



// WEBPACK FOOTER //
// ./src/models/CCCFeed.ts